import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=43fbda2f&"
var script = {}
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=43fbda2f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports